import React, { Component } from 'react'
import GenerateServiceID from './GenerateServiceID'
import GenerateServiceName from './GenerateServiceName'
import GenerateGroupName from './GenerateGroupName'
import ServiceConfirmation from './ServiceConfirmation'

export default class ServiceManagement extends Component {

    state = {
        step: 1,
        email: '',
        username: '',
        password: '',
        firstName: '',
        lastName: '',
        country: '',
        levelOfEducation: '',
    }

    // go back to previous step
    prevStep = () => {
        const { step } = this.state;
        this.setState({ step: step - 1 });
    }

    // proceed to the next step
    nextStep = () => {
        const { step } = this.state;
        this.setState({ step: step + 1 });
    }

    // Handle fields change
    handleChange = input => e => {
        this.setState({ [input]: e.target.value });
    }

    render() {
        const { step } = this.state;
        const { email, username, password, firstName, lastName, country, levelOfEducation } = this.state;
        const values = { email, username, password, firstName, lastName, country, levelOfEducation }

        switch(step) {
            case 1:
                return (
                    <GenerateServiceID
                        nextStep={ this.nextStep }
                        handleChange={ this.handleChange }
                        values={ values }
                    />
                )
            case 2:
                return (
                    <GenerateServiceName
                        prevStep={ this.prevStep }
                        nextStep={ this.nextStep }
                        handleChange={ this.handleChange }
                        values={ values }
                    />
                )
            case 3:
                return (
                    <GenerateGroupName
                        prevStep={ this.prevStep }
                        nextStep={ this.nextStep }
                        handleChange={ this.handleChange }
                        values={ values }
                    />

                )
            case 4:
                return (
                    <ServiceConfirmation
                        values={ values }
                    />
                )

            default:

            // do nothing
        }
    }
}